"use client";

import { COOKIES } from ".constants/cookies";
import { FEATURE_FLAGS } from ".constants/featureFlags";
import { some } from "lodash";
import { FC, PropsWithChildren } from "react";
import { useCookies } from "react-cookie";
import { useMount } from "react-use";

import { createCustomContext } from "./context";
import { useProfileContext } from "./ProfileProvider";

/**
 * ABC-test редизайна
 */
// Конфигурация групп
export const AB_TEST_REDESIGN_GROUPS_1 = [
  { segment: 0, abc: 1 }, // group1
  { segment: 1, abc: 2 }, // group2
  { segment: 2, abc: 0 }, // group3
  { segment: 3, abc: 1 }, // group4
  { segment: 4, abc: 2 }, // group5
];

export const AB_TEST_REDESIGN_GROUPS_2 = [
  { segment: 5, abc: 0 }, // group1
  { segment: 5, abc: 1 }, // group2
  { segment: 5, abc: 2 }, // group3
  { segment: 5, abc: 2 }, // group4
  { segment: 5, abc: 0 }, // group5
];

interface IProps {
  EmailTriggerFree: boolean | null;
  EmailTriggerVip: boolean | null;
  AAB_RedesignV1: boolean | null;
  AAB_RedesignV2: boolean | null;
  AB_notification_balance: boolean;
  AB_video_cost: boolean;
}

const [Context, useABtestContext] = createCustomContext<IProps>({
  name: "ABtestContext",
});
export { useABtestContext };

export const ABtestProvider: FC<PropsWithChildren> = ({ children }) => {
  const profile = useProfileContext();
  // const headers = useHeadersContext();
  // const [cookies] = useCookies(["country"]);
  // const country = cookies.country ?? getCountry(headers);
  const [cookies] = useCookies([
    COOKIES.SUBSCRIBE_EMAIL_IS_SHOWED,
    COOKIES.SEGMENT_AB,
    COOKIES.GA_ABC,
  ]);

  /**
   * Триггеры для попапа с email
   */
  const EmailTriggerFree =
    !cookies.subscribeEmailIsShowed &&
    profile &&
    !profile.isEmailSubscribed &&
    profile.coins < 1;

  const EmailTriggerVip =
    !cookies.subscribeEmailIsShowed &&
    profile &&
    !profile.isEmailSubscribed &&
    profile.paymentCount > 0 &&
    profile.coins > 0;

  /**
   * ABC-test редизайна
   */

  // Получаем значения из profile, или из куки если гость
  const segmentAB = profile?.segment_ab ?? cookies.segment_ab;
  const gaABC = profile?.ga_abc ?? cookies.ga_abc;

  // Проверяем принадлежность к тестовым группам
  const isInTestGroupV1 = some(
    AB_TEST_REDESIGN_GROUPS_1,
    (group) => group.segment === segmentAB && group.abc === gaABC,
  );
  const isInTestGroupV2 = some(
    AB_TEST_REDESIGN_GROUPS_2,
    (group) => group.segment === segmentAB && group.abc === gaABC,
  );

  const AAB_RedesignV1 = FEATURE_FLAGS.IS_REDESIGN_ENABLED && isInTestGroupV1;
  const AAB_RedesignV2 = FEATURE_FLAGS.IS_REDESIGN_ENABLED && isInTestGroupV2;

  useMount(() => {
    // document.documentElement.dataset.redesign = AAB_Redesign ? "true" : "false";
    window.document.documentElement.setAttribute(
      "data-redesign-v1",
      String(AAB_RedesignV1),
    );
    window.document.documentElement.setAttribute(
      "data-redesign-v2",
      String(AAB_RedesignV2),
    );
  });

  // AB тест нотификации о заканчивающемся балансе и прпомо пакета на 24ч
  // TODO: запустить после AB теста оживления
  // TODO: убрать AB тест после окончания
  const AB_notification_balance =
    FEATURE_FLAGS.IS_LOCAL_TEST &&
    !!profile &&
    profile.segment_ab === 1 &&
    profile?.ga_ab === 1;

  // AB-test на стоиость генки видео
  const AB_video_cost = !!profile && profile?.ga_ab === 1;

  return (
    <Context
      value={{
        EmailTriggerFree,
        EmailTriggerVip,
        AAB_RedesignV1,
        AAB_RedesignV2,
        AB_notification_balance,
        AB_video_cost,
      }}
    >
      {children}
    </Context>
  );
};
